import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BaseService } from './data.service';
import { AuthService } from './auth.service';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class ProveedorService extends BaseService {
  constructor(httpClient: HttpClient, authService: AuthService) {
    super('v1/proveedores', httpClient, authService);
  }
}